import { Middleware } from '@reduxjs/toolkit'

import DropdownAlert from 'components/dropdown-alert/DropdownAlert'

const errorHandlerMiddleware: Middleware = (store) => (next) => (action) => {
  const { payload } = action
  const isRequestRejected = action.type.includes('apis') && action.type.endsWith('/rejected')
  const isRequestSucceeded = action.type.includes('apis') && action.type.endsWith('/fulfilled')

  if (isRequestRejected) {
    const isClientError = payload?.status === 403 && payload?.data?.isClientVerified === false
    const clientErrorMessage = isClientError && 'Client cannot be verified, you are logged out.'

    DropdownAlert.ref.show({
      isError: true,
      message: clientErrorMessage
        ? clientErrorMessage
        : payload?.data?.message || payload?.data || payload?.error,
    })

    if (payload?.status === 401 || isClientError) {
      store.dispatch({ type: 'RESET' })
      location.reload()
    }

    if (
      payload?.status === 400 &&
      (payload?.data?.message === 'Unregistered client!' ||
        payload?.data?.message === 'Geçersiz istemci numarası')
    ) {
      store.dispatch({ type: 'RESET' })
      location.reload()
    }

    if (
      payload?.status === 400 &&
      (payload?.data?.message === 'Missing clientId' ||
        payload?.data?.message === 'İstemci numarası bulunamadı')
    ) {
      store.dispatch({ type: 'RESET' })
      location.reload()
    }
  }

  if (isRequestSucceeded && payload?.success && payload?.message) {
    DropdownAlert.ref.show({
      isError: false,
      message: payload?.message,
    })
  }

  return next(action)
}

export default errorHandlerMiddleware
